// extracted by mini-css-extract-plugin
export var actionIcon = "_pu-0";